var React = require('react');

function Gf (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fill":"#078930","d":"M0 0h640v480z","key":0}),React.createElement("path",{"fill":"#fcdd09","d":"M0 0l640 480H0z","key":1}),React.createElement("path",{"fill":"#da121a","d":"M252.4 218h135.2l-109.4 79.5L320 169l41.8 128.6z","key":2})]);
}

Gf.defaultProps = {"viewBox":"0 0 640 480"};

module.exports = Gf;

Gf.default = Gf;
